import { Show } from "shared/components";
import { Card } from "shared/components/Card";
import { Badge, BadgeSize, BadgeVariant } from "shared/components/Badge";
import { Loader } from "shared/components/Loader";

const StatItem = ({
  value,
  label,
  formatValue
}: {
  value: number | null;
  label: string;
  formatValue?: (value: number) => string;
}) => (
  <div className="flex items-center gap-2 min-w-0">
    <span className="text-2xl font-bold text-content-1000 shrink-0">
      {value === null ? "–" : (formatValue?.(value) ?? value)}
    </span>
    <Badge variant={BadgeVariant.BASE} size={BadgeSize.SM}>
      {label}
    </Badge>
  </div>
);

export const AverageMedianCard = ({
  type,
  average = null,
  median,
  isLoading,
  onClick,
  reserveActionGutter,
  pointInTime,
  medianOnly,
  formatValue
}: {
  type: string;
  average?: number | null;
  median: number | null;
  isLoading: boolean;
  onClick?: () => void;
  reserveActionGutter?: boolean;
  pointInTime?: boolean;
  medianOnly?: boolean;
  formatValue?: (value: number) => string;
}) => (
  <Card
    onClick={onClick}
    className={`h-full !space-y-2 !p-6 ${reserveActionGutter ? "!pr-10" : ""}`}
  >
    <div className="flex items-center gap-2">
      <p className="text-sm font-medium text-content-1000">{type}</p>
      {pointInTime ? (
        <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-alpha-40 text-xs font-medium text-content-500">
          As of today
        </span>
      ) : null}
    </div>
    {isLoading ? (
      <Loader size={24} />
    ) : (
      <div className="flex flex-wrap items-center gap-3">
        <Show if={!medianOnly}>
          <StatItem value={average} label="Average" formatValue={formatValue} />
          <div className="h-5 w-px bg-alpha-100" />
        </Show>
        <StatItem value={median} label="Median" formatValue={formatValue} />
      </div>
    )}
  </Card>
);
